import { useCallback, useEffect, useRef, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'next/router'

import { FmTDrawerUtils } from '@utils/fmtDrawer'

import FollowMyTeamDrawer from './FollowMyTeamDrawer'

const FmTHashHandler = () => {
  const queryClient = useQueryClient()
  const router = useRouter()
  const [openAt, setOpenAt] = useState<
    'showSelectTeam' | 'showMyTeams' | undefined
  >(undefined)
  const hasInitialized = useRef(false)

  const handleCloseDrawer = () => {
    setOpenAt(undefined)
  }

  const checkHashAndUpdateState = useCallback(() => {
    const hash = router.asPath?.split('#')?.[1]
    if (hash?.includes('fmtdrawer')) {
      setOpenAt('showSelectTeam')
    }
  }, [router])

  useEffect(() => {
    if (!hasInitialized.current) {
      checkHashAndUpdateState()
      queryClient.setQueryData<FmTDrawerUtils>(['fmt-drawer-utils'], {
        updateOpenAt: (
          openAt: 'showSelectTeam' | 'showMyTeams' | undefined,
        ) => {
          setOpenAt(openAt)
        },
      })
      hasInitialized.current = true
    }
  }, [checkHashAndUpdateState, openAt, queryClient])

  return <FollowMyTeamDrawer openAt={openAt} onClose={handleCloseDrawer} />
}

export default FmTHashHandler
